import { Link, Typography } from "@material-ui/core";

type DelegateStepsProps = {
  nodeName: string;
};

export const DelegateSteps = (props: DelegateStepsProps) => {
  if (props.nodeName === "Tezos") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Download and login a wallet that supports XTZ staking (
          <Link
            target="_blank"
            href="https://token.im/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              imToken
            </Typography>
          </Link>
          /
          <Link
            target="_blank"
            href="https://trustwallet.com/tezos-wallet/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Trust Wallet
            </Typography>
          </Link>
          /
          <Link
            target="_blank"
            href="https://atomex.me/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Atomic
            </Typography>
          </Link>
          /etc.)
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Copy this delegate address and enter the wallet's staking
          section, paste to choose the validator Wetez
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Click "delegate" to finish the delegation and wait for the
          staking reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/tezos"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "Cosmos") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to{" "}
          <Link
            target="_blank"
            href="https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap?hl=en"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Keplr
            </Typography>
          </Link>{" "}
          plugin wallet
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Click "Stake" to enter the staking section
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Scroll down the page to find the validator Wetez, delegate ATOM
          to Wetez and wait for the staking reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/cosmos"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "Ethereum") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1:Please be sure that{" "}
          <Link
            target="_blank"
            href="https://metamask.io/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Metamask
            </Typography>
          </Link>{" "}
          is installed and ETH account is imported
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2:Enter the{" "}
          <Link
            target="_blank"
            href="https://app.stafi.io/rETH"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              StaFi rToken App
            </Typography>
          </Link>{" "}
          and connect Metamask
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3:Input the amount of ETH that will be staked in the "Stake ETH"
          page.
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step4:Confirm the amount of staked ETH and the Gas fee, click
          "Confirm"
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step5:Check delegation details in the "Status" page
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/eth"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "Polygon") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to{" "}
          <Link
            target="_blank"
            href="https://metamask.io/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Metamask
            </Typography>
          </Link>{" "}
          on Google Chrome
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Open the{" "}
          <Link
            target="_blank"
            href="https://wallet.polygon.technology/staking/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Polygon Staking UI
            </Typography>
          </Link>{" "}
          and click on "connect" in the top right corner to link to the Metamask
          wallet
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Enter "Wetez" or paste validator address copied here to find
          the validator Wetez, click "Delegate" to delegate MATIC to Wetez and
          wait for the staking reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/polygon"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "IoTex") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to{" "}
          <Link
            target="_blank"
            href="https://iopay.iotex.io/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              ioPay
            </Typography>
          </Link>
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2:Visit{" "}
          <Link
            target="_blank"
            href="http://member.iotex.io"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              voting website
            </Typography>
          </Link>{" "}
          to stake when remain logged in ioPay Desktop app (in the case of using
          desktop)
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Enter "Wetez" to find the validator Wetez on the pop-up window,
          delegate IOTX to Wetez and wait for the staking reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/iotex"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "IRISnet") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to the{" "}
          <Link
            target="_blank"
            href="https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap?hl=en"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Keplr
            </Typography>
          </Link>{" "}
          plugin wallet
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Click "Stake" to enter the staking section
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Scroll down the page to find the validator Wetez, delegate IRIS
          to Wetez and wait for the staking reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/irisnet"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "Oasis") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Visit and login to the{" "}
          <Link
            target="_blank"
            href="https://chrome.google.com/webstore/detail/oasis-wallet/ppdadbejkmjnefldpcdjhnkpbjkikoip/related"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Oasis Wallet-Browser Extension
            </Typography>
          </Link>
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Click "Staking" to enter the staking section
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Click "Validator" tab and scroll down the page to find the
          validator Wetez, delegate ROSE to Wetez and wait for the staking
          reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/oasis"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "Solana") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Visit and login to{" "}
          <Link
            target="_blank"
            href="https://solflare.com/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              SolFlare.com
            </Typography>
          </Link>
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Copy the delegate address above and click "STAKE SOLANA" to
          enter the staking section on{" "}
          <Link
            target="_blank"
            href="https://solflare.com/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              SolFlare.com
            </Typography>
          </Link>
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Enter the amount of SOL you want to delegate, paste Wetez’s
          delegate address to delegate to Wetez and wait for the staking reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/solana"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "Wanchain") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to the{" "}
          <Link
            target="_blank"
            href="https://www.wanchain.org/getstarted/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Wanchain Desktop Wallet
            </Typography>
          </Link>
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Copy the delegate address above and enter the delegation
          section via "Galaxy" - "Delegation" on the wallet
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Paste Wetez’s delegate address, enter the amount of WAN to
          delegate to Wetez and wait for the staking reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/wanchain"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "Kava") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to the{" "}
          <Link
            target="_blank"
            href="https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap?hl=en"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Keplr
            </Typography>
          </Link>{" "}
          plugin wallet
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Click "Stake" to enter the staking section
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Scroll down the page to find the validator Wetez, delegate KAVA
          to Wetez and wait for the staking reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/kava"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "Akash") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to the{" "}
          <Link
            target="_blank"
            href="https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap?hl=en"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Keplr
            </Typography>
          </Link>{" "}
          plugin wallet
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Click "Stake" to enter the staking section
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Scroll down the page to find the validator Wetez, delegate AKT
          to Wetez and wait for the staking reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/akash"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "Alaya") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to the{" "}
          <Link
            target="_blank"
            href="https://www.platon.network/en/developer/#aton"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              ATON
            </Typography>
          </Link>{" "}
          wallet
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Click "Delegate" to enter the delegate related section
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Scroll down the page to find the validator Wetez, delegate ATP
          to Wetez and wait for the staking reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/alaya"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "Meter") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to the{" "}
          <Link
            target="_blank"
            href="https://www.meter.io/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Meter desktop wallet
            </Typography>
          </Link>
          , create or import a wallet account
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Enter the delegation process via "Staking"- "Buckets voted to
          me" - "CREATE VOTE"
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Select the validator Wetez and enter the amount of MTRG you
          want to delegate, then sign to delegate and wait for the staking
          reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/meter"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "Sifchain") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to the{" "}
          <Link
            target="_blank"
            href="https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap?hl=en"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Keplr
            </Typography>
          </Link>{" "}
          plugin wallet
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Click "Stake" to enter the staking section
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Scroll down the page to find the validator Wetez, delegate
          ROWAN to Wetez and wait for the staking reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/sifchain"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "Polkadex") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to the{" "}
          <Link
            target="_blank"
            href="https://chrome.google.com/webstore/detail/polkadot%7Bjs%7D-extension/mopnmbcafieddcagagdcbnhejhlodfdd?hl=en"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              {"polkadot{.js} extension"}
            </Typography>
          </Link>
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Visit staking section of{" "}
          <Link
            target="_blank"
            href="https://polkadot.js.org/apps/?rpc=wss%3A%2F%2Fmainnet.polkadex.trade#/stakingmainnet.polkadex.trade#/explorer"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Polkadex app
            </Typography>
          </Link>{" "}
          and connect to your wallet account, then continue via "Account
          actions"-"+ Nominator"
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Enter the amount of PDEX you want to delegate, then find the
          validator Wetez by inputting "Wetez" or pasting the address copied
          here, delegate PDEX to Wetez and wait for the staking reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/polkadex"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "Mina") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to{" "}
          <Link
            target="_blank"
            href="https://www.aurowallet.com/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Auro wallet
            </Typography>
          </Link>{" "}
          on Google Chrome
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Click "Staking"-"go to staking" to enter the staking section
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Enter "Wetez" or paste address copied here to find the
          validator Wetez, delegate MINA to Wetez and wait for the staking
          reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/mina"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "Findora") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Download and install{" "}
          <Link
            target="_blank"
            href="https://wallet.findora.org/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Findora
            </Typography>
          </Link>{" "}
          Wallet
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Create or import a wallet account
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Enter the delegation process via staking-stake and select the
          validator Wetez for delegation
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/findora"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "Edgeware") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to the{" "}
          <Link
            target="_blank"
            href="https://chrome.google.com/webstore/detail/polkadot%7Bjs%7D-extension/mopnmbcafieddcagagdcbnhejhlodfdd?hl=en"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              {"polkadot{.js} extension"}
            </Typography>
          </Link>
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Visit staking section of{" "}
          <Link
            target="_blank"
            href="https://polkadot.js.org/apps/?rpc=wss%3A%2F%2Fedgeware.api.onfinality.io%2Fpublic-ws#/staking"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Edgeware
            </Typography>
          </Link>{" "}
          and connect to your wallet account, then continue via "Account
          actions"-"+ Nominator"
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Enter the amount of you want to delegate, then find the
          validator Wetez by inputting "Wetez" or pasting the address copied
          here, delegate EDG to Wetez and wait for the staking reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/edgeware"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "ChainX") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to the{" "}
          <Link
            target="_blank"
            href="https://chrome.google.com/webstore/detail/polkadot%7Bjs%7D-extension/mopnmbcafieddcagagdcbnhejhlodfdd?hl=en"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              {"polkadot{.js} extension"}
            </Typography>
          </Link>
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Visit staking section of{" "}
          <Link
            target="_blank"
            href="https://dapps.chainx.org/#/staking/staking"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              ChainX app
            </Typography>
          </Link>{" "}
          and connect to your wallet account
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Find the validator Wetez by scroll down the page, enter the
          amount of PCX, delegate PXC to Wetez and wait for the staking reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/chainx"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "IOST") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to{" "}
          <Link
            target="_blank"
            href="https://chrome.google.com/webstore/detail/iwallet/kncchdigobghenbbaddojjnnaogfppfj?hl=en-GB"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              iWallet
            </Typography>
          </Link>{" "}
          on Google Chrome
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Visit{" "}
          <Link
            target="_blank"
            href="https://www.iostabc.com/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              IOSTABC browser
            </Typography>
          </Link>{" "}
          via the same chrome browser, click "Producer Vote" tab
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Enter "Wetez" or paste address copied here to find the
          validator Wetez, delegate MINA to Wetez and wait for the staking
          reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/iost"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "NFTMart") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to the{" "}
          <Link
            target="_blank"
            href="https://chrome.google.com/webstore/detail/polkadot%7Bjs%7D-extension/mopnmbcafieddcagagdcbnhejhlodfdd?hl=en"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              {"polkadot{.js} extension"}
            </Typography>
          </Link>
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Visit staking section of{" "}
          <Link
            target="_blank"
            href="https://polkadot.js.org/apps/?rpc=wss%3A%2F%2Fmainnet.nftmart.io%2Frpc%2Fws#/staking"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              NFTMart
            </Typography>
          </Link>{" "}
          and connect to your wallet account, then continue via "Account
          actions"-"+ Nominator"
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Enter the amount of NMT you want to delegate, then find the
          validator Wetez by inputting "Wetez" or pasting the address copied
          here, delegate NMT to Wetez and wait for the staking reward
        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/nftmart"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }
  if (props.nodeName === "Evmos") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Login to the MetaMask on the{" "}
          <Link
            target="_blank"
            href="https://evmos.me/wallet"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Evmos Wallet
            </Typography>
          </Link>{" "}
          
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Click "Stake" to enter the staking section
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Paste the validator address that copied here to the “Destination” box and enter the amount of EVMOS, then delegate to Wetez and wait for the staking reward        </Typography>

        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/evmos"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }
  if (props.nodeName === "Juno") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to the{" "}
          <Link
            target="_blank"
            href="https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap?hl=en"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Keplr
            </Typography>
          </Link>{" "}
          plugin Wallet
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Open the <Link
            target="_blank"
            href="https://juno.omniflix.co/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Omniflix UI page
            </Typography>
          </Link>  and click on "connect" in the top right corner to link to the Keplr wallet
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Scroll down the page to find the validator Wetez, click "delegate" to delegate JUNO to Wetez and wait for the staking reward
        </Typography>
        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/juno"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }
  if (props.nodeName === "Umee") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to the{" "}
          <Link
            target="_blank"
            href="https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap?hl=en"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Keplr
            </Typography>
          </Link>{" "}
          plugin Wallet
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Click "Stake" to enter the staking section
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Scroll down the page to find the validator Wetez, delegate UMEE to Wetez and wait for the staking reward
        </Typography>
        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/umee"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "Nym") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          Step1: Install and login to the{" "}
          <Link
            target="_blank"
            href="https://nymtech.net/download/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Nym Desktop Wallet
            </Typography>
          </Link>
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Copy the delegate address above and enter the “Delegation” section on the wallet
        </Typography>

        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
           Step3: Paste Wetez’s delegate address, enter the amount of NYM to delegate to Wetez and wait for the staking reward
        </Typography>
        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/nym-mixnode"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "OmniFlix") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        >
          The staking function is not live yet, stay tuned. 
        </Typography>

         
        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/omniflix-coming-soon"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "Gravity-Bridge") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        > 
          Step1: Login to the <Link
            target="_blank"
            href="https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap?hl=en"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              Keplr
            </Typography>
          </Link> plugin wallet on the 
          <Link
            target="_blank"
            href="https://gravity-bridge.ezstaking.io/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
              ezstaking
            </Typography>
          </Link> front end

        </Typography>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Click "Validator" to enter the staking section
        </Typography>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Type “Wetez” to find the validator Wetez, delegate GRAVITON to Wetez and wait for the staking reward
        </Typography>
        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guide/gravity-bridge"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "Myriad") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        > 
          Step1: Login to the <Link
            target="_blank"
            href="https://mainnet.oct.network/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
             Octopus Network
            </Typography>
          </Link> with <Link
            target="_blank"
            href="https://wallet.near.org/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
             NEAR wallet
            </Typography>
          </Link> 
          

        </Typography>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2: Enter the staking section via “Appchains”- “myriad”
        </Typography>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Scroll down the page to find the validator “wetezpos.near”, delegate OTC to Wetez and wait for the staking reward
        </Typography>
        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guides/myriad"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }

  if (props.nodeName === "DebioNetwork") {
    return (
      <>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="31px"
        > 
          Step1: Login to the <Link
            target="_blank"
            href="https://mainnet.oct.network/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
             Octopus Network
            </Typography>
          </Link> with <Link
            target="_blank"
            href="https://wallet.near.org/"
            sx={{ textDecorationColor: "#00A5F6", color: "#00A5F6" }}
          >
            <Typography
              fontSize="18px"
              lineHeight="18px"
              color="primary"
              mt="28px"
              component="span"
            >
             NEAR wallet
            </Typography>
          </Link> 
          

        </Typography>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step2:  Enter the staking section via “Appchains”- “debionetwork”
        </Typography>
        <Typography
          fontSize="18px"
          lineHeight="18px"
          color="secondary"
          mt="14px"
        >
          Step3: Scroll down the page to find the validator “wetezpos.near”, delegate OTC to Wetez and wait for the staking reward
        </Typography>
        <Link
          target="_blank"
          href="https://docs.wetez.io/wetez/staking-guides/debio-network"
          sx={{ textDecorationColor: "#E4E9EB", color: "#E4E9EB" }}
        >
          <Typography
            fontSize="18px"
            lineHeight="18px"
            color="secondary"
            mt="28px"
          >
            More details…
          </Typography>
        </Link>
      </>
    );
  }
  return null;
};
